import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import { H3 } from '../../../../AbstractElements';
import { MonthlyRevenueGrowth } from '../../../Constants';
import { growthCardData } from '../../../../Data/Dashboard/Default';
import { GrowthCardProps } from '../../../../Types/Dashboard.type';
import axios from 'axios';
import { format } from 'date-fns';
import { baseUrl } from '../../../Baseurl/Baseurl';
import { ApexOptions } from 'apexcharts';

export default function GrowthCard({ colClass, cardClass, height, chartClass }: GrowthCardProps) {
    const [active, setActive] = useState('Weekly');
    const [tokenData, setTokenData] = useState<{ x: string; y: number }[]>([]);

    useEffect(() => {
        fetchTokenData();
    }, []);
    const fetchTokenData = async () => {
        try {
          const response = await axios.get(`${baseUrl}tokenregistration/monthlyTokenCount`);
          
          const formattedData = response.data.map((item: { appointmentdate: string; token_count: number }) => ({
              x: format(new Date(item.appointmentdate), 'yyyy-MM-dd'), // No need to append "T00:00:00Z"
              y: item.token_count
          }));
      
          setTokenData(formattedData);
        } catch (error) {
          console.error("Error fetching token data:", error);
        }
      };
      
    
    const growthChart: ApexOptions = {
        series: [
            {
                name: 'Tokens Issued',
                data: tokenData.length ? tokenData : [{ x: 'No Data', y: 0 }]
            }
        ],
        chart: {
            type: 'area' as 'area', // ✅ Explicitly defining type
            height: height,
            toolbar: { show: false }
        },
        xaxis: {
            type: 'category',
            categories: tokenData.map((item) => item.x),
            labels: { format: 'dd MMM' }
        },
        yaxis: {
            title: { text: 'Token Count' }
        },
        stroke: { curve: 'smooth' },
        colors: ['#008FFB']
    };

    return (
        <div className={colClass}>
            <Card className={cardClass || ''}>
                <CardHeader className="card-no-border pb-0">
                    <div className="header-top">
                       
                    </div>
                </CardHeader>
                <CardBody className="pb-0">
                    <div className={chartClass || ''} id="growth-chart">
                        <ReactApexChart type="area" options={growthChart} series={growthChart.series} height={height} />
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
